module.exports = __webpack_public_path__ + "static/media/kiosks-management.38f3cc15.svg";